// =============================================================================
// changelog.js — o que mudou no Fênix, na linguagem de quem usa.
//
// ⚠️ ESTA É A ÚNICA FONTE DE VERDADE DA VERSÃO. Não existe CHANGELOG.md ao lado
//    deste arquivo, de propósito: changelog que mora em dois lugares diverge na
//    primeira pressa, e o que fica desatualizado é sempre o que ninguém vê. O
//    que está aqui é o que a tela mostra.
//
// ⚠️ TODA ALTERAÇÃO ENTRA AQUI. Se mudou o que o usuário vê, faz ou espera,
//    vira uma linha nesta lista — antes do commit, não depois. Mudança interna
//    que ninguém percebe (refatoração, teste, comentário) não precisa de linha;
//    mas se ela mudou COMPORTAMENTO, precisa, mesmo que o motivo seja técnico.
//
// COMO ESCREVER: o leitor é o vendedor, não o programador. Diga o que mudou na
// tela e o que isso resolve para ele. "senha_busca vira índice HMAC" não diz
// nada a quem vende; "o orçamento abre na hora depois da senha" diz tudo.
//
// A versão de cima é a que aparece na barra lateral. Numeração: o meio sobe a
// cada rodada de trabalho, o último dígito fica para correção solta.
// =============================================================================

export const VERSOES = [
  {
    versao: '0.5.0',
    data: '2026-10-29',
    resumo: 'O Fênix passa a falar com o Microuniverso na hora: o que a tela mostra é lido agora, e o orçamento confirmado já nasce no ERP.',
    mudancas: [
      {
        tipo: 'novo',
        texto: 'Confirmar manda o orçamento direto para o Microuniverso, como Apenas orçando, e a tela mostra o número '
          + 'que ele recebeu lá. Leva por volta de um minuto: espere a mensagem antes de fechar.',
      },
      {
        tipo: 'novo',
        texto: 'Se o Microuniverso não responder, o pedido aparece como "Sem resposta do ERP", com o botão '
          + '"Procurar de novo no Microuniverso". O Fênix nunca manda o mesmo orçamento duas vezes.',
      },
      {
        tipo: 'melhoria',
        texto: 'Produto, estoque, preço e cliente são lidos do Microuniverso na hora — não há mais "dados de ontem".',
      },
      {
        tipo: 'melhoria',
        texto: 'Item de Caixa sai da loja da venda. Para o cliente retirar em outra loja, use Expedição — o Fênix avisa antes de confirmar.',
      },
      {
        tipo: 'melhoria',
        texto: 'Desconto acima da alçada não confirma enquanto a liberação do gerente não existir no Fênix.',
      },
      {
        tipo: 'novo',
        texto: 'Cadastrar cliente vai direto ao Microuniverso, sem sair do orçamento. Começa pelo CPF/CNPJ: '
          + 'se ele já é cliente, entra no orçamento na hora. Para quem já é cliente, "adicionar endereço" '
          + 'acrescenta um endereço de entrega (nome e documento se corrigem no Microuniverso).',
      },
      {
        tipo: 'melhoria',
        texto: 'Produto que só tem saldo em outra loja já entra como Expedição, saindo da filial com mais saldo. '
          + 'Caixa é sempre da loja da venda — antes a tela oferecia "Cliente leva na filial 06", que só dava erro no fim.',
      },
      {
        tipo: 'correcao',
        texto: 'Rascunho retomado mostra o nome do produto, a opção de onde sai a mercadoria e o endereço atual do cliente '
          + '(o mesmo que vai para o Microuniverso). O endereço do documento mostra o complemento.',
      },
      {
        tipo: 'correcao',
        texto: 'Frases que se contradiziam: "Nada foi gravado ainda" com o rascunho salvo, "Disponível na sua loja" '
          + 'junto de "Sem saldo", e a explicação da opção anterior aparecendo por um instante ao trocar de onde sai a mercadoria. '
          + 'Item de Caixa não reclama mais de data que nem aparece na tela.',
      },
      {
        tipo: 'correcao',
        texto: 'Sem forma de pagamento ou tipo de documento, o Fênix avisa antes de confirmar — antes o '
          + 'Microuniverso recusava com "Tipo de documento do parcelamento não informado".',
      },
      {
        tipo: 'novo',
        texto: 'Usuários e Perfis voltam a funcionar: a lista traz os usuários dos portais e os vendedores do '
          + 'Microuniverso, e dar um perfil libera o acesso na hora. Sem perfil, a pessoa não entra e não vende.',
      },
      {
        tipo: 'correcao',
        texto: 'Rascunho retomado em outro dia não volta com previsão vencida: a data fica em branco e o item '
          + 'pede uma nova.',
      },
      {
        tipo: 'melhoria',
        texto: 'Produto sem saldo na sua loja mostra qual filial tem e pede para escolher de onde sai, em vez de '
          + 'sugerir encomenda logo de cara.',
      },
    ],
  },
  {
    versao: '0.4.0',
    data: '2026-08-24',
    resumo: 'O histórico de compra do cliente chega ao balcão, os rascunhos ganham lugar próprio e a senha do vendedor deixou de fazer esperar.',
    mudancas: [
      {
        tipo: 'melhoria',
        texto: 'A senha do vendedor abre o orçamento na hora. Antes levava cerca de 12 segundos, '
             + 'porque o sistema conferia a senha contra todos os 231 vendedores, um por um.',
      },
      {
        tipo: 'novo',
        texto: 'O cadastro de cliente começa pelo CPF/CNPJ. Se o cliente já existir, a ficha abre '
             + 'preenchida com o que o Microuniverso sabe — dá para conferir e corrigir. Se não '
             + 'existir, a ficha abre em branco. Ninguém mais digita tudo para descobrir no fim '
             + 'que o cliente já era cadastrado.',
      },
      {
        tipo: 'melhoria',
        texto: 'O CPF e o CNPJ são conferidos na hora, com o dígito verificador, e ganham máscara '
             + 'enquanto se digita. Quem não tem o documento do cliente em mãos usa o atalho '
             + '"cadastrar sem CPF/CNPJ".',
      },
      {
        tipo: 'correcao',
        texto: 'Ao corrigir um cadastro, o CEP ficava "buscando…" para sempre, sem ninguém ter '
             + 'digitado nada.',
      },
      {
        tipo: 'correcao',
        texto: 'Trocar o CEP de um cliente que já tinha endereço não trocava o endereço. Agora '
             + 'troca — mas continua sem apagar o que você mesmo digitou.',
      },
      {
        tipo: 'correcao',
        texto: 'A lista de forma de pagamento agora é a do Microuniverso: A VISTA, NOTINHA 30, '
             + '01 X, Entrada + 02 X e as outras que a loja usa, na ordem do mais usado. Antes '
             + 'a tela mostrava uma lista de exemplo que não existia no ERP.',
      },
      {
        tipo: 'novo',
        texto: 'Tipo de documento no orçamento: Dinheiro, PIX, Administradora de Cartões, BOLETO, '
             + 'NOTINHA, Crédito Devolução e cheque. Vai junto para o Microuniverso.',
      },
      {
        tipo: 'novo',
        texto: 'Histórico de compra do cliente: no bloco CLIENTE do orçamento, o link "histórico de '
             + 'compra" abre o que ele levou nos últimos 12 meses — data, loja, vendedor, produto, '
             + 'quantidade e o preço que ele pagou. Pedido de vocês na reunião de hoje.',
      },
      {
        tipo: 'novo',
        texto: 'Menu Rascunhos: os orçamentos que você começou e não confirmou ficam listados, '
             + 'com o cliente, quantos itens e quando você mexeu neles pela última vez. Dá para '
             + 'continuar qualquer um, ver o documento ou descartar. Antes só era possível '
             + 'retomar um de cada vez, pelo aviso que aparecia ao abrir o orçamento.',
      },
      {
        tipo: 'novo',
        texto: 'Esta tela. A versão aparece na barra lateral e diz o que mudou em cada uma.',
      },
      {
        tipo: 'correcao',
        texto: 'Em Dados sincronizados, "ofertas" e "histórico de compra" apareciam sem explicação '
             + 'e sempre em vermelho, porque o painel não conhecia o prazo delas.',
      },
    ],
  },
  {
    versao: '0.3.0',
    data: '2026-08-22',
    resumo: 'O catálogo passa a conhecer as ofertas e a achar produto por palavras soltas.',
    mudancas: [
      {
        tipo: 'novo',
        texto: 'As ofertas do Microuniverso chegam ao Fênix: o preço mostrado é o que a loja está '
             + 'praticando, não a tabela cheia.',
      },
      {
        tipo: 'melhoria',
        texto: 'A busca de produto acha por palavras soltas e fora de ordem — "cimento saco" '
             + 'encontra "SACO DE CIMENTO", como já era de esperar.',
      },
    ],
  },
  {
    versao: '0.2.0',
    data: '2026-08-21',
    resumo: 'O orçamento vira o impresso do Microuniverso, e nada mais se perde no meio da venda.',
    mudancas: [
      {
        tipo: 'novo',
        texto: 'A tela de novo orçamento passa a ser o próprio documento, no formato do impresso '
             + 'do Microuniverso: o vendedor reconhece o papel em vez de aprender tela nova.',
      },
      {
        tipo: 'novo',
        texto: 'O orçamento em digitação se salva sozinho. Fechar o navegador por engano, ou a '
             + 'máquina desligar, não custa mais uma hora de trabalho.',
      },
      {
        tipo: 'novo',
        texto: 'A senha do vendedor passa a dizer de quem é a venda, como no Microuniverso — é ela '
             + 'que define a comissão.',
      },
      {
        tipo: 'novo',
        texto: 'Cadastro e correção de cliente sem sair da venda, com o endereço começando pelo '
             + 'CEP. O que se cadastra aqui entra na fila do Microuniverso, e a tela diz isso.',
      },
      {
        tipo: 'novo',
        texto: 'Catálogo, estoque, clientes e fotos do ERP espelhados: 56 mil clientes com '
             + 'endereço, e a foto do produto vinda do SIC.',
      },
      {
        tipo: 'novo',
        texto: 'Escolha da filial que atende cada item, com a diferença entre transferir e faturar '
             + 'direto de lá.',
      },
      {
        tipo: 'correcao',
        texto: 'Errar a senha do vendedor derrubava o login e mandava a pessoa de volta para a '
             + 'tela de entrada no meio da venda.',
      },
      {
        tipo: 'correcao',
        texto: 'Senha certa de vendedor sem acesso liberado respondia "senha não reconhecida" — e '
             + 'a pessoa tentava de novo até travar.',
      },
    ],
  },
  {
    versao: '0.1.0',
    data: '2026-08-20',
    resumo: 'O começo: vender com o Microuniverso fora do ar.',
    mudancas: [
      {
        tipo: 'novo',
        texto: 'Login, lista de pedidos e a primeira tela de orçamento.',
      },
      {
        tipo: 'novo',
        texto: 'O espelho do ERP e a fila de integração: o pedido é capturado aqui e devolvido ao '
             + 'Microuniverso como orçamento aberto quando ele volta.',
      },
    ],
  },
];

export const VERSAO = VERSOES[0].versao;

// Os rótulos são o que aparece na tela — com acento, como manda a casa.
export const TIPOS = {
  novo: { rotulo: 'Novo', icone: 'bi-stars' },
  melhoria: { rotulo: 'Melhoria', icone: 'bi-arrow-up-circle' },
  correcao: { rotulo: 'Correção', icone: 'bi-wrench-adjustable' },
};
